import { render, staticRenderFns } from "./purchase-view.vue?vue&type=template&id=00818d8d&scoped=true&"
import script from "./purchase-view.vue?vue&type=script&lang=ts&"
export * from "./purchase-view.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-view.vue?vue&type=style&index=0&id=00818d8d&prod&lang=scss&scoped=true&"
import style1 from "./purchase-view.vue?vue&type=style&index=1&id=00818d8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00818d8d",
  null
  
)

export default component.exports